<script setup lang="ts">
import { hexAlpha, mixColor } from '@/utils/levels';

// Faixa de nível do header do jogo (Figma 22526:60672). Ocupa a LARGURA TODA
// da barra, numa linha só pra ela, e tudo fica LADO A LADO:
// [emblema] · [Elo: lv N] · [barra] · [NN%]. Sem placa nem moldura próprias —
// a faixa se apoia no fundo chapado da barra e só o preenchimento do XP
// carrega a cor do elo.
//
// NÃO é clicável: a faixa mora a um dedo do topo do jogo, e um toque errado
// tirava o jogador da partida sem querer. Quem quiser ver o progresso todo tem
// o "Meu nível" na bandeja do header. Por isso é uma <div> com role de imagem,
// e não um <button>.
const { tier, level, levelProgress, currentLevelLabel } = useLevelsProgress();

const progressLabel = computed(() => Math.round(levelProgress.value));
</script>

<template>
  <!-- SEM `relative` no root: quem monta posiciona (o `.relative` do Tailwind
       vence o `.absolute` do pai com important:true — já nos mordeu). -->
  <div
    :aria-label="currentLevelLabel"
    class="levels-ingame flex w-full items-center gap-[5px]"
    role="img"
  >
    <!-- Emblema em tamanho cheio: antes era um fundo de 52px atravessando a
         borda da faixa e clipado em três lados pra não vazar, o que comia a
         largura do texto e cortava o brasão. -->
    <span
      aria-hidden="true"
      class="h-[19px] w-[23.7px] flex-none bg-contain bg-center bg-no-repeat"
      :style="{
        backgroundImage: `url(${tier.badge})`,
        filter: 'drop-shadow(0 1.4px 4.9px rgba(0,0,0,.55))',
      }"
    ></span>

    <!-- Nome do elo em negrito + "lv N" apagado, do jeito que o Figma escreve
         (era "· nível N"). `shrink-0` porque quem cede espaço é a barra. -->
    <span
      class="shrink-0 whitespace-nowrap text-[11.2px] font-semibold leading-[11.2px] text-white/60"
    >
      <b class="font-bold text-white">{{ tier.name }}:</b>
      lv {{ level }}
    </span>

    <span
      class="block h-[10px] min-w-0 flex-1 overflow-hidden rounded-full bg-[rgba(0,25,101,0.74)] shadow-[inset_0_1.1px_2.3px_rgba(0,0,0,0.5)]"
    >
      <span
        class="block h-full rounded-full"
        :style="{
          width: `${levelProgress}%`,
          background: `linear-gradient(90deg,${tier.color},${mixColor(tier.color, '#ffffff', 0.42)})`,
          boxShadow: `0 0 9px ${hexAlpha(tier.color, 0.9)}`,
        }"
      ></span>
    </span>

    <span
      class="shrink-0 text-[11.2px] font-bold leading-[11.2px] text-white tabular-nums"
    >
      {{ progressLabel }}%
    </span>
  </div>
</template>
